import React, {Fragment} from 'react'
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames'

export function Accordion ({ list, title }) {
  if (list.length === 0) {
    return null
  }

  const [showSpecifications, setShowSpecifications] = React.useState(false)

  const accordionRows = list.map((item, index) => {
    return (
      <Fragment key={index}>
        <div
          key={index}
          className={classNames('mtt-accordion__headers', {
            'mtt-accordion__headers--padding': index > 0
          })}
        >
          <div className='mtt-accordion__header'>
            {item.label}
          </div>

          <div className='mtt-accordion__header'>
            {item.value}
          </div>
        </div>

        {item.variants && item.variants.length > 0 && item.variants.map((variantItem, index) => (
          <div key={index} className='mtt-accordion__headers'>
            <div className='mtt-accordion__header'>
              <div className='mtt-accordion__variants'>

                <div className='mtt-accordion__variant'>
                  - {variantItem.label}
                </div>
              </div>
            </div>

            <div className='mtt-accordion__header'>
              {variantItem.value}
            </div>
          </div>
        ))}
      </Fragment>
    )
  })
  return (
    <div className={classNames('mtt-accordion', { active: showSpecifications })}>
      <div className='mtt-accordion__title-wrapper' onClick={() => setShowSpecifications(!showSpecifications)}>
        {title}
      </div>

      <AnimateHeight
        duration={ 500 }
        height={ showSpecifications ? 'auto' : 0 }
      >
        <div className='mtt-accordion__content-wrapper'>
          {accordionRows}
        </div>
      </AnimateHeight>
    </div>
  )
}
